// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e-signature-container{padding:10px 40px}`, "",{"version":3,"sources":["webpack://./src/components/rip/commitment/Signatures/Electronic/ElectronicSignature.scss"],"names":[],"mappings":"AAAA,uBACI,iBAAA","sourcesContent":[".e-signature-container {\n    padding: 10px 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
